import {generalHelpers} from '../helpers/general';

export class Header {
  init() {
    this.header = document.querySelector('.navbar,.navigation');
    this.sticky = this.header.offsetTop;
    this.sayHello = this.onScroll.bind(this);
    window.addEventListener('scroll', (e) => this.onScroll(e));
    this.toggleMenu();
  }

  onScroll() {
    if (window.pageYOffset > this.sticky) {
      this.header.classList.add('sticky');
      document.body.style.paddingTop = this.header.offsetHeight;
    } else {
      this.header.classList.remove('sticky');
      document.body.style.paddingTop = 0;
    }
  }

  toggleMenu() {
    document.querySelector('.navigation .js-toggle-menu').addEventListener('click', function() {
      generalHelpers.toggleClass(document.querySelector('.navigation .menu'), 'shown');
    });
  }

}

